<template>
	<div>
		<div class="site-footer-bg-1 wow slideInLeft" data-wow-delay="100ms" data-wow-duration="2500ms"
			style="background-image: url(static/image/site-footer-shape-2.png);">
		</div>
		<div class="site-footer-bg-2 wow slideInRight" data-wow-delay="100ms" data-wow-duration="2500ms"
			style="background-image: url(static/image/site-footer-shape-2.png);">
		</div>
		<div class="site-footer__top">
			<div class="container">
				<div class="site-footer__top-inner">
					<div class="site-footer__top-left">
						<div class="site-footer__top-icon">
							<span class="icon-artificial-intelligence"></span>
						</div>
						<h3 class="site-footer__top-title">
							<!-- 奥太30年专业经验，5000+企业的信任之选！ -->
							{{ $t('footer.footer_top_title') }}
							<div style="font-size: var(--font-size-16);color: #aea8b9;">
								<!-- 免费领取 90天奥太产品体验特权，开启您的焊接制造智能化升级 -->
								{{ $t('footer.footer_top_subtitle') }}
							</div>
						</h3>

					</div>
					<div class="site-footer__top-right">
						<!-- href="https://www.icloudweld.com/login.jsp" target="_blank" -->
						<a @click="handleSeek" class="thm-btn site-footer__btn">
							<!-- 申请体验 -->
							{{ $t('footer.footer_top_btn') }}
						</a>
					</div>
				</div>
			</div>
		</div>
		<div class="site-footer__middle">
			<div class="container">
				<div class="row">
					
					<div class="col-xl-2 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="200ms">
						<div class="footer-widget__column footer-widget__links clearfix">
							<h3 class="footer-widget__title" @dblclick="handleSystem">
								<!-- 快捷入口 -->
								{{ $t('footer.footer_links_title') }}
							</h3>
							<ul class="footer-widget__links-list list-unstyled clearfix">
								<li>
									<router-link to="about">
										<!-- 关于我们 -->
										{{ $t('header.contactUs') }}
									</router-link>
								</li>
								<li>
									<router-link to="productList">
										<!-- 产品中心 -->
										{{ $t('header.productCenter') }}
									</router-link>
								</li>
								<li>
									<router-link to="news">
										<!-- 新闻资讯 -->
										{{ $t('header.news') }}
									</router-link>
								</li>
								<li>
									<router-link to="solutionList">
										<!-- 解决方案 -->
										{{ $t('header.solution') }}
									</router-link>
								</li>
							</ul>
						</div>
					</div>
					<div class="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="300ms">
						<div class="footer-widget__column footer-widget__contact clearfix">
							<h3 class="footer-widget__title">
								<!-- 联系我们 -->
								{{ $t('footer.footer_contact_title') }}
							</h3>
							<ul class="footer-widget__contact-list list-unstyled clearfix">
								<li>
									<div class="icon">
										<span class="icon-telephone"></span>
									</div>
									<div class="text">
										<p><a>(+86)132-0531-8830</a>
											<!-- 王经理 -->
											{{ $t('footer.footer_contact_manager_wang') }}
										</p>
										<p><a>(+86)183-5314-7789</a>
											<!-- 许经理 -->
											{{ $t('footer.footer_contact_manager_xu') }}
										</p>
									</div>
								</li>
								<li>
									<div class="icon">
										<span class="icon-email"></span>
									</div>
									<div class="text">
										<!-- href="mailto:aotaiqunkong@163.com" -->
										<p><a >qunkong@aotaidianqi.com</a></p>
									</div>
								</li>
								<li>
									<div class="icon">
										<span class="icon-pin"></span>
									</div>
									<div class="text">
										<p>
											<!-- 济南市高新区伯乐路282号 -->
											{{ $t('footer.footer_contact_address') }}
											<br></p>
									</div>
								</li>
							</ul>
						</div>
					</div>
					<div class="col-xl-7 col-lg-12 col-md-12 wow fadeInUp" data-wow-delay="400ms">
						<div class="footer-widget__column footer-widget__social-box clearfix">
							<div class="site-footer__social">
								<!-- <div style="text-align: center;display: none;">
									<img src="static/picture/common/atgw.jpg" alt="" srcset="" style="height: 150px;">
									<span style="color: #fff;">奥太官方微信公共号</span>
								</div> -->
								<div style="text-align: center;">
									<img src="static/picture/common/atzy.jpg" alt="" srcset="" style="height: 140px;">
									<div>
										<span style="color: #fff;">
											<!-- 山东奥太焊接云系统 -->
											{{ $t('footer.footer_qrcode_weldCloud') }}
										</span>
									</div>
								</div>
								
								<div style="text-align: center;">
									<img src="static/picture/common/app_groupControl_download.png" alt="" srcset="" style="height: 140px;">
									<div>
										<span style="color: #fff;">
											<!-- 掌上群控APP -->
											{{ $t('footer.footer_qrcode_groupControl') }}
										</span>
									</div>
								</div>
								
								<div style="text-align: center;">
									<img src="static/picture/common/app_operations_download.png" alt="" srcset="" style="height: 140px;">
									<div>
										<span style="color: #fff;">
											<!-- 掌上运维APP -->
											{{ $t('footer.footer_qrcode_operations') }}
										</span>
									</div>
								</div>
								<div style="text-align: center;">
									<img src="static/picture/common/wqk.jpg" alt="" srcset="" style="height: 140px;">
									<div>
										<span style="color: #fff;">
											<!-- 奥太微群控小程序 -->
											{{ $t('footer.footer_qrcode_miniProgram') }}
										</span>
									</div>
								</div>

								<!-- <div style="text-align: center; margin-right: 50px;">
									<img src="static/picture/common/wang.png" alt="" srcset="" style="height: 140px;">
									<div>
										<span style="color: #fff;">联系我们</span>
									</div>
								</div>
								<div style="text-align: center;">
									<img src="static/picture/common/xu.png" alt="" srcset="" style="height: 140px;">
									<div>
										<span style="color: #fff;">联系我们</span>
									</div>
								</div> -->
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="site-footer__bottom">
			<div class="container">
				<div class="row">
					<div class="col-xl-12">
						<div class="site-footer__bottom-inner">
							<p class="site-footer__bottom-text">Copyright &copy;{{ year }} <a target="_blank"
									:href="official">
									{{ $t('footer.footer_copyright_company') }}
									<!-- footer_copyright_company -->
								</a>&nbsp; All rights reserved　<a target="_blank"
									href="http://beian.miit.gov.cn/">
									<!-- 鲁ICP备15016186号-5 -->
									{{ $t('footer.footer_copyright_icp') }}
								</a>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		 <!-- <seek-dialog v-if="seekShow" labelTitle="行业名称"  @close="handleClose"/> -->
	</div>
</template>
<script >
// import SeekDialog from "@/components/seekDialog.vue"
export default {
    name: 'footerAotai',
    components: {
		// SeekDialog
    },
    data () {
        return {        
			year: new Date().getFullYear(),
			seekShow: false, 
			official: window._address_env_.official || ''
        }
    },
  
    methods: {
        // 联系我们 
        handleSeek() {
			this.$emit("handleSeek")
			// this.seekShow = true
        },

		handleSystem() {
				console.log("双击系统显示")

				const targetRoute = this.$router.resolve({ path: '/system' });
   				 window.open(targetRoute.href, '_blank');

		},
    }
}
</script>
<style scoped>
.site-footer__social {
    display: flex;
	justify-content: space-between;
	/* justify-content: center; */
}

.site-footer-bg-2 {
    position: absolute;
    bottom: 0;
    right: 0;
    height: 625px;
    width: 531px;
    background-color: var(--notech-black);
    background-blend-mode: luminosity;
    background-repeat: no-repeat;
    background-position: bottom center;
    background-size: cover;
    opacity: .12;
    z-index: -1;
}
</style>